module.exports = __webpack_public_path__ + "static/img/curtain.a0bb913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/curtain.png
// module id = HdUK
// module chunks = 1